<template>
  
  <b-card>
    <div  v-if="permission_check(client_module.menu_permission,30) === false">
      <b-alert show variant="danger" class="p-3 text-center">
        You don't have permission to access this page.
      </b-alert>
    </div>
    <div  v-if="permission_check(client_module.menu_permission,30)">
    <b-modal
      id="modal-xl"
      ref="modal-remarks"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      
      button-size="sm"
      size="md"
      title="Remarks"
    >
      <app-timeline>
    <app-timeline-item
      v-for="remark in full_remarks" :key="index" 
      :title=remark.display_name
      :subtitle=remark.remarks
      :icon="remark.icon"
      :time="remark.formatted_datetime"
      :variant="remark.type"
    />
  </app-timeline>
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>
      <Snapshot
    :is-snap-shot-sidebar-active.sync="isSnapShotSidebarActive"
    :user-data="userData"
    user-type="STAFF"
    @clicked="one"
  />
    <!-- Alert: No item found -->
    <b-tabs>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Account</span>
        </template>
        <div>

          <!-- Header: Personal Info -->
          <div class="d-flex">
            <feather-icon
              icon="UserIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              Personal Information
            </h4>
          </div>
          <b-row>
              <b-col md="6" lg="6">
          <!-- Form: Personal Info Form -->
          <b-form class="mt-1">
            <b-row>

              <!-- Field: Mobile -->
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Display Name"
                  label-for="display_name"
                >
                  <b-form-input
                    id="display_name"
                    v-model="userData.display_name"
                  />
                </b-form-group>
              </b-col>
              <!-- <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Personal Trainer Rate"
                  label-for="Personal Trainer Rate"
                >
                  <b-form-input
                    id="pt_rate"
                    v-model="userData.pt_rate"
                  />
                </b-form-group>
              </b-col> -->
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Username"
                  label-for="username"
                >
                  <b-form-input
                    id="username"
                    v-model="userData.username"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Status"
                  label-for="status"
                >
                  <v-select
                    v-model="userData.status"
                    :reduce="option => option.value"
                    :options="statusOptions"
                    :clearable="false"
                    input-id="status"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="5"
              >
                <b-form-group
                  label="Country Code"
                  label-for="country_code"
                >
                  <v-select
                    v-model="userData.country_code"
                    :options="countryCodeOptions"
                    :clearable="false"
                    :reduce="ans => ans.value"
                    input-id="country_code"
                  />

                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="7"
              >
                <b-form-group
                  label="Mobile"
                  label-for="Mobile"
                >
                  <b-form-input
                    id="mobile"
                    v-model="userData.mobile"
                  />
                </b-form-group>
              </b-col>
             
              <b-col
                cols="12"
                md="6"
                lg="8"
              >
                <b-form-group
                  label="Group"
                  label-for="Group"
                >
                  <v-select
                    v-model="userData.group_id"
                    :reduce="ans => ans.id"
                    label="name"
                    :options="groupOptions"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Entry Reocrd"
                  label-for="entry_record"
                >
                  <v-select
                    v-model="userData.entry_record"

                    :options="['Y','N']"
                    :clearable="false"
                    input-id="entry_record"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="6"
              > 
                <b-form-group
                  label="Default Login Centers"
                  label-for="default_center_id"
                >
                  <v-select
                    v-model="userData.default_center_id"
                    label="label"
                    :reduce="c => c.value"
                    :options="centerOptions"
                    :clearable="false"
                    input-id="default_center_id"
                  />
                </b-form-group>
              </b-col>
               <b-col
                cols="12"
                md="6"
                lg="6"
              >
                <b-form-group
                  label="Related Member"
                  label-for="role"
                >
                <v-select
                v-model="userData.related_member_id"
                @search="fetchOptions"
                :options="memberOptions"
                :clearable="true"
                :filterable="false"
                placeholder="Please Enter Member Code..."
                input-id="Client"
                :reduce="member_id => member_id.value"
              >
              <template v-slot:spinner="{ loading }">
                <div v-show="loading">Loading...</div>
              </template>
              </v-select>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="12"
              >
                <b-form-group
                  label="Access Centers"
                  label-for="access_centers"
                >
                  <v-select
                    v-model="userData.access_center"

                    :options="centerOptions"
                    :clearable="false"
                    multiple
                    input-id="access_center"
                  />
                </b-form-group>
              </b-col>
              
             
              
            </b-row>
           <div class="divider"  v-if="client_module.module.includes('hr')">
            <div class="divider-text divider-cloudfit">
               HR Information
            </div>
          </div>
            <div v-if="client_module.module.includes('hr')">
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="6"
              >
                <b-form-group
                  label="English Name"
                  label-for="English Name"
                >
                  <b-form-input
                    id="en_name"
                    v-model="userData.en_name"
                  />
  
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="6"
              >
                <b-form-group
                  label="Chinese Name"
                  label-for="Chinese Name"
                >
                  <b-form-input
                    id="zh_name"
                    v-model="userData.zh_name"
                  />
  
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Email"
                  label-for="Email"
                >
                  <b-form-input
                    id="Email"
                    v-model="userData.email"
                  />
  
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="HKID"
                  label-for="HKID"
                >
                  <b-form-input
                    id="HKID"
                    v-model="userData.hkid"
                  />
  
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Birth"
                  label-for="Birth"
                >
                 <flat-pickr v-model="userData.birth" class="form-control" :config="{ dateFormat: 'Y-m-d'}" placeholder="YYYY-MM-DD"/>
  
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="6"
                lg="12"
              >
                <b-form-group
                  label="Address"
                  label-for="Address"
                >
                  <b-form-input
                    id="Address"
                    v-model="userData.address"
                  />
  
                </b-form-group>
              </b-col>
                <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Join Date"
                  label-for="Join Date"
                >
                <flat-pickr v-model="userData.join_date" class="form-control" :config="{ dateFormat: 'Y-m-d'}" placeholder="YYYY-MM-DD"/>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="8"
              >
               <b-form-group
                  label="Department"
                  label-for="Department"
                >
                   <v-select
                    v-model="userData.department_id"
                    :reduce="department_list => department_list.id"
                    :options="departmentOptions"
                    :clearable="false"
                    :searchable="true"
                    label="label"
                    input-id="status"
                  />
  
                </b-form-group>
                </b-col>
            </b-row>
            <div class="divider">
            <div class="divider-text divider-cloudfit">
              Bank Information
            </div>
          </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="12"
              >
                <b-form-group
                  label="Bank Name"
                  label-for="Bank Name"
                >
                   <v-select
                    v-model="userData.bank_name"
                    :reduce="option => option.id"
                    :options="bankOptions"
                    :clearable="false"
                    :searchable="true"
                    label="name"
                    input-id="status"
                  />
  
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="12"
              >
                <b-form-group
                  label="Bank Account"
                  label-for="Bank Account"
                >
                  <b-form-input
                    id="bank_account"
                    v-model="userData.bank_account_number"
                  />
  
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            </div>
            <b-row class="mt-2">
              <b-col>
                <b-button
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="save_staff"
                >
                  Save Changes
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  :to="{ name: 'staff-list' }"
                >
                  Cancel
                </b-button>
                <b-button
                  variant="danger"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="reset_password"
                >
                  Reset Password
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
        <b-col md="4" lg="3">
            <img
              style="width:100%;border-radius:10px;"
              ref="previewEl"
              @error="userData.avatar = ''"
              :src="userData.avatar"
              size="100%"
              rounded
            /><br>
            <!-- <b-button
              class="mt-1"
              block
              variant="primary"
              @click="go()"
            >
            <feather-icon icon="CameraIcon" />
             <span> {{ $t('Start Camera') }} </span>
            </b-button> -->

            <b-button
            class="mt-1"
            block
            variant="primary"
            @click="snapshot2()"
          >
          <feather-icon icon="CameraIcon" />
           <span> {{ $t('Start Camera') }} </span>
          </b-button>


            <b-button
              class="mt-1"
              block
              variant="outline-primary"
              @click="update_card()"
            >
            <feather-icon icon="RssIcon" />
            <span  v-if="userData.card_id"> {{ $t('Update Card') }} </span>
            <span  v-if="!userData.card_id"> {{ $t('Register Card') }} </span>
            </b-button>
 <b-button
            class="mt-1"
            block
            variant="outline-primary"
            :disabled="isSendQrCodeLoading"
            @click="send_qr_code()"
          >
          
           <span v-if="isSendQrCodeLoading">  <b-spinner small class="mr-50" /> </span>
           <span v-else>  <font-awesome-icon icon="fa-solid fa-qrcode"  />  {{ $t('Send Access QR Code') }} </span>
          </b-button>
            <b-button
            class="my-1"
            block
            variant="outline-success"
            :disabled="disable_button"
            @click="update_to_device()"
          >
          <feather-icon icon="RefreshCwIcon" />
           <span> {{ $t('Update Access Control') }}</span>
          </b-button>

          <b-button
            class="my-1"
            block
            variant="outline-danger"
            v-if="userData.is_locked === true"
            @click="unlock_user()"
          >
          <feather-icon icon="UnlockIcon" />
           <span> {{ $t('Unlock') }}</span>
          </b-button>

        </b-col>
        <b-col lg="3">
          <h4 class="mb-1">
                  {{ $t('Remarks') }} 
              </h4>
              <b-button-group size="sm" style="width:100%;">
                       <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
       @click="remarks_type = 'primary'"
      variant="outline-primary"
    >
      <feather-icon :icon="'Edit2Icon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-info"
       @click="remarks_type = 'info'"
    >
           <feather-icon :icon="'InfoIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-danger"
       @click="remarks_type = 'danger'"
    >
     <feather-icon :icon="'AlertTriangleIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-warning"
       @click="remarks_type = 'warning'"
    >
           <feather-icon :icon="'BellIcon'" />
    </b-button>

  </b-button-group>
    <b-form-textarea id="remarks" v-model="remarks_input" class="my-1"/>
    <b-button size="sm" block class="mb-1" @click="submit_remarks" :variant="remarks_type">Submit</b-button>
    <hr />
          <app-timeline>

    <app-timeline-item
      v-for="remark in remarks" :key="index" 
      :variant="remark.type"
      :icon="remark.icon"
    >

      <div class="d-flex align-items-start flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-50">
        
        <h6>{{remark.display_name}}</h6>
        <b-badge
          
          variant="light-primary"
        >
          {{remark.formatted_datetime }}
        </b-badge>
      </div>
      <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
       <div>{{ remark.remarks }}</div>
        <div v-if="permission_check(client_module.functions,40)">
          <feather-icon icon="Trash2Icon" style="color:red;cursor: pointer;" @click="delete_remarks(remark.id)"/>
        </div>
      </div>
    </app-timeline-item>
  </app-timeline>
  <b-button @click="view_log()" class="mt-1" block size="sm" variant="outline-secondary">View All</b-button>
</b-col>
      </b-row>
        </div>
      </b-tab>
      <b-tab  v-if="client_module.module.includes('staff_package')">
        <template #title>
                    <font-awesome-icon icon="fa-solid fa-right-to-bracket" class="mr-1"/>
          <span class="d-none d-sm-inline">Package</span>
        </template>
        <tab-staff-package
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <font-awesome-icon icon="fa-solid fa-box" class="mr-1"/>
          <span class="d-none d-sm-inline">Entry</span>
        </template>
        <tab-staff-entry
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <b-tab>
        <template #title>
                   <font-awesome-icon icon="fa-solid fa-hand-holding-dollar" class="mr-1"/>

          <span class="d-none d-sm-inline">Commission Set</span>
        </template>
        <tab-staff-commission
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <b-tab>
        <template #title>
        <font-awesome-icon icon="fa-solid fa-file-invoice-dollar" class="mr-1"/>
          <span class="d-none d-sm-inline">PT Session Set</span>
        </template>
        <tab-staff-session
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <b-tab  v-if="client_module.module.includes('cloud_drive')">
        <template #title>
          <feather-icon
            icon="HardDriveIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">{{ $t('Drive') }}</span>
        </template>
        <tab-staff-drive
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <b-tab  v-if="client_module.module.includes('hr')">
        <template #title>
        <font-awesome-icon icon="fa-solid fa-person-chalkboard" class="mr-1"/>
          <span class="d-none d-sm-inline">{{ $t('Leave') }}</span>
        </template>
        <tab-staff-leave
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
    </div>
  </b-card>
</template>

<script>
import {
  BFormTextarea, BAlert, BLink,  BCard, BRow, BCol,BButtonGroup,  BForm, BFormGroup, BListGroup, BListGroupItem, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import tabStaffPackage from './TabStaffPackage.vue'
import tabStaffEntry from './TabStaffEntry.vue'
import tabStaffCommission from './TabStaffCommission.vue'
import Snapshot from './SidebarSnapshot.vue'
import tabStaffSession from './TabStaffSession.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import TabStaffDrive from './TabStaffDrive.vue'
import TabStaffLeave from './TabStaffLeave.vue'

import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    TabStaffDrive,
    AppTimeline,
    TabStaffLeave,
    flatPickr,
    AppTimelineItem,
    ToastificationContent,
    tabStaffPackage,BListGroup, BListGroupItem,
    tabStaffCommission,
     'v-easy-camera': EasyCamera,
    tabStaffEntry,
    tabStaffSession,
    vSelect, 
    BForm,
    BFormGroup,
    BFormInput,
    BButtonGroup, 
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BButton,
    BSpinner,
    Snapshot,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
  data() {
    return {
      client_module:JSON.parse(localStorage.getItem('userData')),
      centerOptions: [],
      isSnapShotSidebarActive:false,
      isSendQrCodeLoading: false,
      remarks:[],
      full_remarks:[],
      remarks_input: null,
      remarks_type: 'primary',
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      countryCodeOptions: [
                {label: '🇭🇰 Hong Kong +852', value: '852'},
                { label: '🇨🇳 China +86', value: '86' },
                { label: '🇹🇼 Taiwan +886', value: '886' },
                { label: '🇲🇴 Macau +853', value: '853' },
                { label: '🇲🇾 Malaysia +60', value: '60' },
                { label: '🇸🇬 Singapore +65', value: '65' },
                { label: '🇺🇸 United States +1', value: '1' },
                { label: '🇬🇧 United Kingdom +44', value: '44' },
                { label: '🇦🇺 Australia +61', value: '61' },
                { label: '🇨🇦 Canada +1', value: '1' },
                { label: '🇯🇵 Japan +81', value: '81' },
                { label: '🇰🇷 South Korea +82', value: '82' },
                { label: '🇹🇭 Thailand +66', value: '66' },
                { label: '🇵🇭 Philippines +63', value: '63' },
                { label: '🇮🇩 Indonesia +62', value: '62' },
                { label: '🇻🇳 Vietnam +84', value: '84' },
                { label: '🇮🇳 India +91', value: '91' },
                { label: '🇧🇷 Brazil +55', value: '55' },
                { label: '🇲🇽 Mexico +52', value: '52' },
                { label: '🇷🇺 Russia +7', value: '7' },
                { label: '🇮🇹 Italy +39', value: '39' },
                { label: '🇪🇸 Spain +34', value: '34' },
                { label: '🇳🇱 Netherlands +31', value: '31' },
                { label: '🇸🇪 Sweden +46', value: '46' },
                { label: '🇳🇴 Norway +47', value: '47' },
                { label: '🇩🇰 Denmark +45', value: '45' },
                { label: '🇫🇮 Finland +358', value: '358' },
                { label: '🇵🇱 Poland +48', value: '48' },
                { label: '🇧🇪 Belgium +32', value: '32' },
                { label: '🇨🇭 Switzerland +41', value: '41' },
                { label: '🇦🇹 Austria +43', value: '43' },
                { label: '🇮🇪 Ireland +353', value: '353' },
                { label: '🇵🇹 Portugal +351', value: '351' },
                { label: '🇬🇷 Greece +30', value: '30' },
                { label: '🇨🇿 Czech Republic +420', value: '420' },
                { label: '🇭🇺 Hungary +36', value: '36' },
            ],
      bankOptions:[],
      memberOptions:[],
      groupOptions:[],
      departmentOptions: [],
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled' },
      ],
      roleOptions: [
        { label: 'Admin', value: 'admin' },
        { label: 'Manager', value: 'manager' },
        { label: 'Staff', value: 'staff' },
        { label: 'Senior PT', value: 'senior_pt' },
        { label: 'PT', value: 'pt' },
        { label: 'Rental PT', value: 'rental_pt' },
      ],
    }
  },
   directives: {
    Ripple,
  },
  created() {
    this.get_staff_data()
    this.get_center_data()
    this.get_group_data()
    if (this.client_module.module.includes('hr')) {
      this.get_bank_name()
      this.get_department()
    }
    
  },
  
  methods: {
    get_department() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/hr/departments/')
        .then(res => {
          this.departmentOptions = res.data.departments
        })
    },
    get_bank_name() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/hr/banks/')
        .then(res => {
          this.bankOptions = res.data.banks
        })
    },
    get_staff_remarks(limit) {
      this.$http.get(process.env.VUE_APP_API_BASE+`/staff/${this.userData.uuid}/remarks/?limit=`+limit)
        .then(res => {
          this.full_remarks = res.data.remarks
          if (res.data.remarks.length <= 5) {
            this.remarks = res.data.remarks
          }
        })
    },
    unlock_user() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/staff/${this.userData.uuid}/unlock/`)
                .then(res => {
                    if (res.data.result === true) {
                          this.get_staff_data()

                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
    },
    update_to_device() {
            this.$http.post(`https://www.cloudfit.pro/access_control/api/v1/upload/${this.userData.uuid}?type=user`)
                .then(res => {
                    if (res.data.result === true) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
    fetchOptions (search, loading) {
      setTimeout(() => {
      this.$http.get(process.env.VUE_APP_API_BASE+'/search/member/?string='+search)
            .then(res => {
              this.memberOptions = res.data
            })
            }, 200);
      },
         snapshot2() {
      this.isSnapShotSidebarActive = true
    },
    close() {
      this.full_remarks = []
      this.$refs['modal-remarks'].hide()
    },
     view_log() {
        this.get_staff_remarks(50)
      this.$refs['modal-remarks'].show()
    },
     submit_remarks() {
     this.$http.post(process.env.VUE_APP_API_BASE+`/staff/${this.userData.uuid}/remarks/`, {remarks: this.remarks_input,type:this.remarks_type})
        .then(res => {
          if (res.data.result === true) {
            this.remarks_input = null
            this.remarks_type = 'primary'
            this.get_staff_remarks(5)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
     delete_remarks(id) {
     this.$http.post(process.env.VUE_APP_API_BASE+`/staff/${this.userData.uuid}/remarks/delete/`, {id: id})
        .then(res => {
          if (res.data.result === true) {
            this.get_staff_remarks(5)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    send_qr_code() {
      if (this.isSendQrCodeLoading === true) {
        return
      }
      this.isSendQrCodeLoading = true
       this.$http.post(process.env.VUE_APP_API_BASE+`/staff/${this.userData.uuid}/send_qr_code/`)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
        .finally(() => {
          this.isSendQrCodeLoading = false
        })
    },
    update_card() {
         localStorage.setItem('reader_action', 'update_user_card')
         localStorage.setItem('user_id', this.userData.user_id)
         this.$swal({
          title: 'Please Scan NFC Card',
          icon: 'info',
          allowOutsideClick: false,
          confirmButtonText: this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            localStorage.setItem('reader_action', 'normal')
            localStorage.removeItem('user_id')
          }
        })
    },
        one() {
      this.isSnapShotSidebarActive = false
      this.get_staff_data()
    },
    go() {
        window.location = 'https://www.cloudfit.pro/snapshot.php?type=user&token='+this.userData.token
    },
    save_staff() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/staff/${this.userData.uuid}/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_staff_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_group_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/groups/')
        .then(res => {
          this.groupOptions = res.data.groups
        })
    },
    reset_password() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/staff/reset_password/${router.currentRoute.params.id}/`)
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: res.data.message,
              icon: 'XIcon',
              variant: 'information',
            },
          })
        })
    },
    get_staff_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/staff/${router.currentRoute.params.id}/`)
        .then(res => {
          this.userData = res.data
          this.get_staff_remarks(5)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.divider-cloudfit {
  font-size:11px !important;
  color:#888 !important;
}
</style>
